'use strict';

var Css = require("bs-css-emotion/lib/js/src/Css.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Link$PvpcontrollerWeb = require("./Link.js");
var Image$PvpcontrollerWeb = require("./Image.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var ChangeModel$PvpcontrollerWeb = require("../models/ChangeModel.js");
var MobileDetect$PvpcontrollerWeb = require("../MobileDetect.js");

var baseEntry_0 = Css.fontSize(Css.px(18));

var baseEntry_1 = {
  hd: Css.color(Theme$PvpcontrollerWeb.textColor),
  tl: {
    hd: Css.alignItems(Css.center),
    tl: {
      hd: Css.child("td")({
            hd: Css.padding(Css.px(10)),
            tl: /* [] */0
          }),
      tl: {
        hd: Css.height(Css.px(74)),
        tl: /* [] */0
      }
    }
  }
};

var baseEntry = {
  hd: baseEntry_0,
  tl: baseEntry_1
};

var entry = Curry._1(Css.style, {
      hd: Css.backgroundColor(Theme$PvpcontrollerWeb.panelColor),
      tl: baseEntry
    });

var altEntry = Curry._1(Css.style, {
      hd: Css.backgroundColor(Css.hex("33373c")),
      tl: baseEntry
    });

var nerfOrBuff = Curry._1(Css.style, {
      hd: Css.maxWidth(Css.px(12)),
      tl: /* [] */0
    });

var buffArrow = Curry._1(Css.style, {
      hd: Css.color(Theme$PvpcontrollerWeb.green),
      tl: {
        hd: Css.fontSize(Css.px(22)),
        tl: {
          hd: Css.paddingLeft(Css.px(10)),
          tl: {
            hd: Css.paddingRight(Css.px(10)),
            tl: {
              hd: Css.width(Css.px(12)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var nerfArrow = Curry._1(Css.style, {
      hd: Css.color(Theme$PvpcontrollerWeb.red),
      tl: {
        hd: Css.fontSize(Css.px(25)),
        tl: {
          hd: Css.paddingLeft(Css.px(10)),
          tl: {
            hd: Css.paddingRight(Css.px(10)),
            tl: {
              hd: Css.width(Css.px(12)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var changeTypeIconTd = Curry._1(Css.style, {
      hd: Css.maxWidth(Css.px(50)),
      tl: {
        hd: Css.textAlign(Css.center),
        tl: /* [] */0
      }
    });

var changeTypeIcon = Curry._1(Css.style, {
      hd: Css.width(Css.px(50)),
      tl: {
        hd: Css.position(Css.relative),
        tl: {
          hd: Css.top(Css.px(3)),
          tl: /* [] */0
        }
      }
    });

var imageTd = Curry._1(Css.style, {
      hd: Css.textAlign(Css.center),
      tl: /* [] */0
    });

var image = Curry._1(Css.style, {
      hd: Css.maxHeight(Css.px(30)),
      tl: {
        hd: Css.maxWidth(Css.px(30)),
        tl: /* [] */0
      }
    });

var subjectName = Curry._1(Css.style, {
      hd: Css.color(Theme$PvpcontrollerWeb.textColor),
      tl: /* [] */0
    });

var changeValues = Curry._1(Css.style, {
      hd: Css.minWidth(Css.px(100)),
      tl: /* [] */0
    });

var changeArrow = Curry._1(Css.style, {
      hd: Css.paddingLeft(Css.px(10)),
      tl: {
        hd: Css.paddingRight(Css.px(10)),
        tl: /* [] */0
      }
    });

function spacer(simplfied) {
  if (simplfied) {
    return Curry._1(Css.style, {
                hd: Css.width({
                      NAME: "percent",
                      VAL: 30.0
                    }),
                tl: /* [] */0
              });
  } else {
    return Curry._1(Css.style, {
                hd: Css.width({
                      NAME: "percent",
                      VAL: 10.0
                    }),
                tl: /* [] */0
              });
  }
}

var unconfirmedTd = Curry._1(Css.style, {
      hd: Css.minWidth(Css.px(130)),
      tl: /* [] */0
    });

var unconfirmed = Curry._1(Css.style, {
      hd: Css.background(Css.hex("23282d")),
      tl: {
        hd: Css.padding(Css.px(5)),
        tl: {
          hd: Css.borderRadius(Css.px(5)),
          tl: {
            hd: Css.color(Css.orange),
            tl: /* [] */0
          }
        }
      }
    });

var author = Curry._1(Css.style, {
      hd: Css.marginLeft(Css.auto),
      tl: {
        hd: Css.height({
              NAME: "percent",
              VAL: 100.0
            }),
        tl: {
          hd: Css.display("flex"),
          tl: {
            hd: Css.alignItems(Css.center),
            tl: {
              hd: Css.marginRight(Css.px(20)),
              tl: {
                hd: Css.color(Theme$PvpcontrollerWeb.subTitleColor),
                tl: /* [] */0
              }
            }
          }
        }
      }
    });

var dateTd = Curry._1(Css.style, {
      hd: Css.minWidth(Css.px(141)),
      tl: /* [] */0
    });

function changeDisplay(change) {
  if (ChangeModel$PvpcontrollerWeb.isSimpleValueChange(change)) {
    return React.createElement("td", {
                className: changeValues
              }, ChangeModel$PvpcontrollerWeb.oldAsString(change), React.createElement("i", {
                    className: "fas fa-long-arrow-alt-right " + changeArrow
                  }), ChangeModel$PvpcontrollerWeb.newAsString(change));
  } else {
    return React.createElement("td", {
                className: changeValues
              }, ChangeModel$PvpcontrollerWeb.getComplexValueChange(change));
  }
}

var row = Curry._1(Css.style, {
      hd: Css.display("flex"),
      tl: {
        hd: Css.flexDirection(Css.column),
        tl: {
          hd: Css.justifyContent(Css.spaceBetween),
          tl: /* [] */0
        }
      }
    });

var topRowPart = Curry._1(Css.style, {
      hd: Css.width({
            NAME: "percent",
            VAL: 100.0
          }),
      tl: {
        hd: Css.display("flex"),
        tl: {
          hd: Css.alignItems(Css.center),
          tl: {
            hd: Css.flex3(1.0, 1.0, Css.zero),
            tl: {
              hd: Css.minHeight(Css.rem(3.0)),
              tl: /* [] */0
            }
          }
        }
      }
    });

var middleRowPart = Curry._1(Css.style, {
      hd: Css.width({
            NAME: "percent",
            VAL: 100.0
          }),
      tl: {
        hd: Css.display("flex"),
        tl: {
          hd: Css.alignItems(Css.center),
          tl: {
            hd: Css.justifyContent(Css.spaceBetween),
            tl: {
              hd: Css.flex3(1.0, 1.0, Css.zero),
              tl: /* [] */0
            }
          }
        }
      }
    });

var bottomRowPart = Curry._1(Css.style, {
      hd: Css.width({
            NAME: "percent",
            VAL: 100.0
          }),
      tl: {
        hd: Css.display("flex"),
        tl: {
          hd: Css.alignItems(Css.flexEnd),
          tl: {
            hd: Css.justifyContent(Css.spaceBetween),
            tl: {
              hd: Css.flexGrow(2.0),
              tl: /* [] */0
            }
          }
        }
      }
    });

var nerfOrBuff$1 = Curry._1(Css.style, {
      hd: Css.padding2(Css.zero, Css.rem(0.2)),
      tl: /* [] */0
    });

var imageTd$1 = Curry._1(Css.style, {
      hd: Css.padding4(Css.rem(0.3), Css.rem(0.8), Css.zero, Css.rem(0.2)),
      tl: /* [] */0
    });

var changeTargetName = Curry._1(Css.style, {
      hd: Css.flex3(1.0, 1.0, Css.zero),
      tl: {
        hd: Css.padding2(Css.zero, Css.rem(0.6)),
        tl: /* [] */0
      }
    });

var changeTypeName = Curry._1(Css.style, {
      hd: Css.flex3(1.0, 1.0, Css.zero),
      tl: {
        hd: Css.padding2(Css.zero, Css.rem(0.6)),
        tl: /* [] */0
      }
    });

var mobileEntry = Curry._1(Css.style, {
      hd: Css.height(Css.rem(9.0)),
      tl: /* [] */0
    });

var dateTd$1 = Curry._1(Css.style, {
      hd: Css.paddingLeft(Css.rem(1.0)),
      tl: {
        hd: Css.minWidth(Css.px(141)),
        tl: {
          hd: Css.height(Css.rem(2.3)),
          tl: /* [] */0
        }
      }
    });

var label = Curry._1(Css.style, {
      hd: Css.fontSize(Css.rem(1.1)),
      tl: /* [] */0
    });

var subjectName$1 = Curry._1(Css.style, {
      hd: Css.color(Css.hex("c1c8d4")),
      tl: /* [] */0
    });

var changeTypeIcon$1 = Curry._1(Css.style, {
      hd: Css.width(Css.px(40)),
      tl: {
        hd: Css.position(Css.relative),
        tl: {
          hd: Css.top(Css.px(3)),
          tl: /* [] */0
        }
      }
    });

function ChangeLogEntry$Fake(Props) {
  var alt = Props.alt;
  var $$class = MobileDetect$PvpcontrollerWeb.isMobile(undefined) ? (
      alt ? Curry._1(Css.merge, {
              hd: entry,
              tl: {
                hd: mobileEntry,
                tl: /* [] */0
              }
            }) : Curry._1(Css.merge, {
              hd: altEntry,
              tl: {
                hd: mobileEntry,
                tl: /* [] */0
              }
            })
    ) : (
      alt ? entry : altEntry
    );
  return React.createElement("div", {
              className: $$class
            });
}

function ChangeLogEntry(Props) {
  var alt = Props.alt;
  var change = Props.change;
  var simplifiedOpt = Props.simplified;
  var childrenOpt = Props.children;
  var simplified = simplifiedOpt !== undefined ? simplifiedOpt : false;
  var children = childrenOpt !== undefined ? Caml_option.valFromOption(childrenOpt) : React.createElement(React.Fragment, undefined);
  if (MobileDetect$PvpcontrollerWeb.isMobile(undefined)) {
    var simplifiedOpt$1 = simplified;
    var childrenOpt$1 = Caml_option.some(children);
    var simplified$1 = simplifiedOpt$1 !== undefined ? simplifiedOpt$1 : false;
    var children$1 = childrenOpt$1 !== undefined ? Caml_option.valFromOption(childrenOpt$1) : React.createElement(React.Fragment, undefined);
    var $$class = alt ? Curry._1(Css.merge, {
            hd: entry,
            tl: {
              hd: mobileEntry,
              tl: /* [] */0
            }
          }) : Curry._1(Css.merge, {
            hd: altEntry,
            tl: {
              hd: mobileEntry,
              tl: /* [] */0
            }
          });
    var changeIcon = ChangeModel$PvpcontrollerWeb.isNerf(change) ? React.createElement("i", {
            className: "fas fa-long-arrow-alt-down " + nerfArrow
          }) : React.createElement("i", {
            className: "fas fa-long-arrow-alt-up " + buffArrow
          });
    var imageUrl = ChangeModel$PvpcontrollerWeb.image(change);
    var icon = ChangeModel$PvpcontrollerWeb.changeTypeIcon(change);
    var fallback = icon === "" ? undefined : icon;
    var tmp;
    if (simplified$1) {
      tmp = React.createElement("div", undefined);
    } else {
      var tmp$1;
      if (imageUrl === "") {
        var icon$1 = ChangeModel$PvpcontrollerWeb.changeTypeIcon(change);
        tmp$1 = icon$1 === "" ? React.createElement(React.Fragment, undefined) : React.createElement("div", {
                className: changeTypeIconTd
              }, React.createElement("img", {
                    className: changeTypeIcon$1,
                    src: icon$1
                  }));
      } else {
        tmp$1 = React.createElement("div", {
              className: imageTd$1
            }, React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps(ChangeModel$PvpcontrollerWeb.sourceLink(change), subjectName$1, imageUrl.length > 0 ? React.createElement(Image$PvpcontrollerWeb.make, Image$PvpcontrollerWeb.makeProps(imageUrl, image, undefined, Caml_option.some(fallback), undefined, undefined)) : React.createElement(React.Fragment, undefined), undefined, undefined, undefined, undefined)));
      }
      tmp = React.createElement(React.Fragment, undefined, tmp$1);
    }
    return React.createElement("tr", {
                className: Curry._1(Css.merge, {
                      hd: $$class,
                      tl: {
                        hd: row,
                        tl: /* [] */0
                      }
                    })
              }, React.createElement("div", {
                    className: topRowPart
                  }, React.createElement("div", {
                        className: changeTargetName
                      }, React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps(ChangeModel$PvpcontrollerWeb.sourceLink(change), subjectName$1, React.createElement("span", {
                                    className: subjectName$1
                                  }, ChangeModel$PvpcontrollerWeb.subjectName(change)), undefined, undefined, undefined, undefined))), React.createElement("div", {
                        className: nerfOrBuff$1
                      }, changeIcon), tmp), React.createElement("div", {
                    className: middleRowPart
                  }, React.createElement("div", {
                        className: changeTypeName
                      }, React.createElement("span", {
                            className: Curry._1(Css.merge, {
                                  hd: Theme$PvpcontrollerWeb.label,
                                  tl: {
                                    hd: label,
                                    tl: /* [] */0
                                  }
                                })
                          }, ChangeModel$PvpcontrollerWeb.changeValueTypeName(change))), changeDisplay(change)), React.createElement("div", {
                    className: bottomRowPart
                  }, change.unconfirmed ? React.createElement("div", {
                          className: unconfirmedTd,
                          title: "This change has not yet been confirmed to be final"
                        }, React.createElement("span", {
                              className: unconfirmed
                            }, "Not Confirmed")) : React.createElement(React.Fragment, undefined), React.createElement("div", {
                        className: dateTd$1
                      }, ChangeModel$PvpcontrollerWeb.Timestamp.toString(change.timestamp, undefined, undefined)), React.createElement("div", undefined, React.createElement("div", {
                            className: author
                          }, React.createElement("img", {
                                className: Theme$PvpcontrollerWeb.smallAvatar,
                                src: "https://t.dark-gaming.com:3001" + change.changedBy.avatar
                              }), change.changedBy.username)), children$1));
  } else {
    var simplifiedOpt$2 = simplified;
    var childrenOpt$2 = Caml_option.some(children);
    var simplified$2 = simplifiedOpt$2 !== undefined ? simplifiedOpt$2 : false;
    var children$2 = childrenOpt$2 !== undefined ? Caml_option.valFromOption(childrenOpt$2) : React.createElement(React.Fragment, undefined);
    var $$class$1 = alt ? entry : altEntry;
    var changeIcon$1 = ChangeModel$PvpcontrollerWeb.isNerf(change) ? React.createElement("i", {
            className: "fas fa-long-arrow-alt-down " + nerfArrow
          }) : React.createElement("i", {
            className: "fas fa-long-arrow-alt-up " + buffArrow
          });
    var imageUrl$1 = ChangeModel$PvpcontrollerWeb.image(change);
    var icon$2 = ChangeModel$PvpcontrollerWeb.changeTypeIcon(change);
    var fallback$1 = icon$2 === "" ? undefined : icon$2;
    var tmp$2;
    if (simplified$2) {
      tmp$2 = React.createElement("td", undefined);
    } else {
      var tmp$3;
      if (imageUrl$1 === "") {
        var icon$3 = ChangeModel$PvpcontrollerWeb.changeTypeIcon(change);
        tmp$3 = icon$3 === "" ? React.createElement(React.Fragment, undefined) : React.createElement("td", {
                className: changeTypeIconTd
              }, React.createElement("img", {
                    className: changeTypeIcon,
                    src: icon$3
                  }));
      } else {
        tmp$3 = React.createElement("td", {
              className: imageTd
            }, React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps(ChangeModel$PvpcontrollerWeb.sourceLink(change), subjectName, imageUrl$1.length > 0 ? React.createElement(Image$PvpcontrollerWeb.make, Image$PvpcontrollerWeb.makeProps(imageUrl$1, image, undefined, Caml_option.some(fallback$1), undefined, undefined)) : React.createElement(React.Fragment, undefined), undefined, undefined, undefined, undefined)));
      }
      tmp$2 = React.createElement(React.Fragment, undefined, tmp$3, React.createElement("td", undefined, React.createElement(Link$PvpcontrollerWeb.make, Link$PvpcontrollerWeb.makeProps(ChangeModel$PvpcontrollerWeb.sourceLink(change), subjectName, React.createElement("span", {
                            className: subjectName
                          }, ChangeModel$PvpcontrollerWeb.subjectName(change)), undefined, undefined, undefined, undefined))));
    }
    return React.createElement("tr", {
                className: $$class$1
              }, React.createElement("td", {
                    className: nerfOrBuff
                  }, changeIcon$1), tmp$2, React.createElement("td", undefined, React.createElement("span", {
                        className: Theme$PvpcontrollerWeb.label
                      }, ChangeModel$PvpcontrollerWeb.changeValueTypeName(change))), changeDisplay(change), change.unconfirmed ? React.createElement("td", {
                      className: unconfirmedTd,
                      title: "This change has not yet been confirmed to be final"
                    }, React.createElement("span", {
                          className: unconfirmed
                        }, "Not Confirmed")) : React.createElement("td", undefined), React.createElement("td", {
                    className: spacer(simplified$2)
                  }), React.createElement("td", undefined, React.createElement("div", {
                        className: author
                      }, React.createElement("img", {
                            className: Theme$PvpcontrollerWeb.smallAvatar,
                            src: change.changedBy.avatar
                          }), change.changedBy.username)), React.createElement("td", {
                    className: dateTd
                  }, ChangeModel$PvpcontrollerWeb.Timestamp.toString(change.timestamp, undefined, undefined)), children$2);
  }
}

function Fake_makeProps(prim0, prim1, prim2) {
  var tmp = {
    alt: prim0
  };
  if (prim1 !== undefined) {
    tmp.key = prim1;
  }
  return tmp;
}

var Fake = {
  makeProps: Fake_makeProps,
  make: ChangeLogEntry$Fake
};

function makeProps(prim0, prim1, prim2, prim3, prim4, prim5) {
  var tmp = {
    alt: prim0,
    change: prim1
  };
  if (prim2 !== undefined) {
    tmp.simplified = Caml_option.valFromOption(prim2);
  }
  if (prim3 !== undefined) {
    tmp.children = Caml_option.valFromOption(prim3);
  }
  if (prim4 !== undefined) {
    tmp.key = prim4;
  }
  return tmp;
}

var make = ChangeLogEntry;

exports.Fake = Fake;
exports.makeProps = makeProps;
exports.make = make;
/* baseEntry Not a pure module */
